import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {map} from 'rxjs/operators';
import {Config} from '../../config/config';

@Injectable({
  providedIn: 'root'
})
export class PassService {

  /** ===============================================================
   * define variables
   */

  constructor(private http: HttpClient, private config: Config) {
  }

  requestDynamicPass(data) {
    {
      const url = this.config.serverUrl + `api/v2/otp`;
      return this.http.post<any>(url, data)
        .pipe(map( res => {
          return res;
        } ));
    }
  }
}
